import { FilterOutlined } from '@ant-design/icons';
import { Input, Space, Table } from 'antd';
import { ReactElement, useState } from 'react';
import styled from 'styled-components';

const StyledTable = styled(Table)`
  .ant-table-cell.hide {
    display: none;
  }
`;

const Actions = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 24px;
  align-items: end;
`;

const StyledInput = styled(Input)`
  width: 400px;
  border-color: ${(props) => props.theme.colors.brandOrange};
  svg {
    color: ${(props) => props.theme.colors.brandOrange};
  }
`;

export interface ITableProps {
  loading?: boolean;
  endpoint: string;
  pageSize?: number;
  rowKey: string;
  columns: Array<object>;
  filterOptions?: {
    placeholder: string;
    keys: Array<string>;
  };
  onFilterChange?: (value: string) => void;
  actionButtons?: Array<ReactElement> | boolean;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  query: any; //QueryDefinition
  // All other props
  [x: string]: any;
}

const CustomTable = ({
  columns,
  rowKey = 'id',
  query,
  pageSize = 10,
  filterOptions,
  onFilterChange,
  actionButtons,
  loading,
  endpoint,
  ...props
}: ITableProps) => {
  const { data, error, isLoading, isFetching } = query(endpoint);
  const [filterValue, setFilterValue] = useState('');

  if (error) {
    return <p>{error}</p>;
  }

  let filteredData = data;

  if (filterOptions && filterValue?.length) {
    filteredData = data.reduce(
      (
        prevValue: Array<Record<string, unknown>>,
        currentValue: Record<string, unknown>
      ) => {
        filterOptions.keys.forEach((filterProp: string) => {
          if (
            String(currentValue[filterProp])
              .toLowerCase()
              .includes(filterValue.toLowerCase())
          ) {
            if (!prevValue.includes(currentValue)) {
              prevValue.push(currentValue);
            }
          }
        });
        return prevValue;
      },
      []
    );
  }

  const renderActions = () => {
    if (!filterOptions && !actionButtons) {
      return null;
    }
    const actions = [];
    if (filterOptions) {
      actions.push(
        <div>
          <StyledInput
            allowClear
            size="large"
            placeholder={filterOptions.placeholder}
            prefix={<FilterOutlined />}
            onChange={(e) => {
              setFilterValue(e.target.value);
              onFilterChange?.(e.target.value);
            }}
          />
        </div>
      );
    }
    if (actionButtons) {
      actions.push(<Space>{actionButtons}</Space>);
    }
    return <Actions>{actions}</Actions>;
  };

  return (
    <>
      {renderActions()}
      <StyledTable
        {...props}
        loading={isLoading || isFetching || loading}
        size="small"
        columns={columns}
        dataSource={filteredData}
        rowKey={rowKey}
        pagination={{
          pageSize,
          showSizeChanger: false,
        }}
      />
    </>
  );
};

export default CustomTable;
